import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AcubeJobsPage } from '@/pages/acube-jobs';
import { acubeJobsSearchSchema } from '@/routes/-shared/acubeJobsSearchSchema';

/**
 * La lista dei job resta montata e il dettaglio si apre sopra di lei
 * sull'`Outlet` (`$id`), come nella webapp: chiuderlo torna alla lista con i
 * filtri di prima, e il link al job si può condividere.
 */
export const Route = createFileRoute('/admin/_layout/acube-jobs/_layout')({
  component: AcubeJobsLayout,
  validateSearch: acubeJobsSearchSchema,
});

function AcubeJobsLayout() {
  return (
    <>
      <AcubeJobsPage />
      <Outlet />
    </>
  );
}
